module.exports = __webpack_public_path__ + "img/scene3-2.53cf5135.png";